import { ApiMethodDeclaration } from '..';

type ParamsData = {
    adminEmail: string;
    date: string;
    hour?: number;
};

type ResponseData = Array<{
    id: number;
    requestTime: Date;
    path: string;
    method: string;
}>;

export const getAllAdminsActivityRequests: ApiMethodDeclaration<ParamsData, ResponseData> = (
    params,
) => ({
    url: `/admins/activity/all/${encodeURIComponent(params.adminEmail)}/date/${params.date}/requests`,
    method: 'GET',
    params: {
        hour: params.hour,
    },
});
